import { render, staticRenderFns } from "./SystemNotification.vue?vue&type=template&id=6d7245d7&scoped=true&"
import script from "./SystemNotification.vue?vue&type=script&lang=js&"
export * from "./SystemNotification.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotification.vue?vue&type=style&index=0&id=6d7245d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7245d7",
  null
  
)

export default component.exports